<h2 mat-dialog-title>Web Publishing</h2>

<mat-dialog-content>
  <p *ngIf="!spinnerActive">You can use the created web application on the below site URL</p>
  <div class="genarated-link ps-5" *ngIf="!publishStatus && !spinnerActive">
    <div class="link-text pt-2 ">
      <h6>Site URL</h6>  
     <div class="copy-url">
       <span ><a [href]="downLoadURL" target="_blank" class="ellipsis-input">{{downLoadURL}}</a></span>
       <button mat-icon-button (click)="copyToClipboard(downLoadURL)">
        <mat-icon>content_copy</mat-icon>
      </button>
     </div>
   </div>
  </div>
  <p *ngIf="spinnerActive">{{spinnerMessage}}</p>
  <mat-spinner *ngIf="spinnerActive" diameter="40"></mat-spinner>
  <div  *ngIf="isPublished">
    <div class="genarated-link ps-5">
      <div class="link-text pt-2 ">
         <h6>Site URL</h6>  
        <div class="copy-url ">
          <span ><a [href]="downLoadURL" target="_blank" class="ellipsis-input">{{downLoadURL}}</a></span>
          <button mat-icon-button (click)="copyToClipboard(downLoadURL)">
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="dailog-footer-buttons">
  <button mat-button (click)="dialog.closeAll()">Cancel</button>
  <button mat-button color="primary" (click)="dialog.closeAll()">OK</button>
</mat-dialog-actions>